import React, { useEffect, useState } from 'react';
import { Stack, Button } from 'react-bootstrap';
import { useUserActivityQuery } from 'services';
import { useNavigate, useParams } from 'react-router-dom';
import useAuthStore from 'store/auth';
import RecentSocialPost from './RecentSocialPost';
import PaginationBox from 'components/PaginationBox';
import { dataLimits } from 'constants/index';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const RecentActivity: React.FC = () => {
	const { translate } = useTranslate();
	const { id: seekerId, type } = useParams<any>();
	const navigate = useNavigate();
	const [currentPage, setCurrentPage] = useState(1);
	const { user: authUser }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const searchParams = `${Number(seekerId) || Number(authUser?.userId)}?limit=${type ? dataLimits?.allActivity : dataLimits?.recentActivity}&page=${currentPage}`;
	const { data: { docs: myFeeds = [], meta = {} } = {}, refetch } =
		useUserActivityQuery(searchParams);

	useEffect(() => {
		refetch();
	}, [currentPage]);

	return (
		<div className={`social-feed ${type ? 'all-activities' : ''}`}>
			<div className="social-feed-left">
				<Stack className="social-feed-posts">
					{myFeeds?.length > 0 ? (
						<>
							{myFeeds.map((post: any, index: number) => (
								<RecentSocialPost
									post={{
										...post?.post,
										activityType: post?.type,
										createdAt: post?.createdAt,
									}}
									key={`${post?.postId}-${post?.userId}-${index}`}
								/>
							))}
						</>
					) : (
						<Stack className="fw-bold">
							<p className="mb-0">{translate('Common.noPostFound')}</p>
						</Stack>
					)}
				</Stack>

				{!type && meta?.limit < meta?.totalDocs && (
					<div className="text-center text-md-start">
						<Button
							onClick={() => navigate(`/all-activities/${seekerId || authUser?.userId}/all`)}
							className="all-activity-btn fw-bold p-0 bg-transparent border-0"
						>
							{translate('Extras.seeAllActivities')}
						</Button>
					</div>
				)}
				<Stack>
					{type && meta?.limit < meta?.totalDocs && (
						<PaginationBox
							totalData={meta?.totalDocs}
							limit={meta?.limit}
							page={currentPage}
							setCurrentPage={setCurrentPage}
						/>
					)}
				</Stack>
			</div>
		</div>
	);
};

export default RecentActivity;
